import script from "./RegisterPlayers.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterPlayers.vue?vue&type=script&setup=true&lang=js"

import "./RegisterPlayers.vue?vue&type=style&index=0&id=7522065e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7522065e"]])

export default __exports__